import React, { forwardRef } from 'react';
import buttonStyles from 'assets/css/Button.module.css';
import styles from 'assets/css/SMARTGoal.module.css';
import SMARTGoalsApp from 'Components/SMARTGoal/SMARTGoalApp';
import useSMARTGoalOverlay from 'context/SMARTGoalOverlayContext';
import { IconCancel } from '@ace/react-icons';
import logo from 'assets/images/logo.svg';

const SMARTGoalsOverlay = forwardRef((props, forwardedRef) => {
    const { toggleSMARTGoalsOverlay } = useSMARTGoalOverlay();
    const { dashboardVariantID } = props;

    return (
        <div className={styles["sg-overlay__background"]}>
            <div className={styles["sg-overlay__container"]} ref={forwardedRef}>
                <div className={styles["sg-overlay__header--desktop"]}>
                    <div className={styles["sg-overlay__button-wrapper"]}>
                        <div className={styles["sg-overlay__close-btn"]} onClick={() => toggleSMARTGoalsOverlay()}>
                            <span className={`${buttonStyles.floating} `}><IconCancel fill="#87A0AF" /></span>
                            <span>Save & Exit</span>
                        </div>
                    </div>
                </div>
                <div className={styles["sg-overlay__header--mobile"]}>
                    <div className={styles["sg-overlay__button-wrapper"]}>
                        <span className={`${buttonStyles.floating} ${styles["sg-overlay__close-btn"]} `} onClick={() => toggleSMARTGoalsOverlay()} ><IconCancel /></span>
                    </div>
                    <div className={styles["sg-overlay__header--icon"]}><img src={logo} /></div>
                </div>
                <div className={styles["sg-app_wrapper"]}>
                    <SMARTGoalsApp dashboardVariantID={dashboardVariantID} />
                </div>
            </div>
        </div>
    );
});

export default SMARTGoalsOverlay;
